var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-main',{staticStyle:{"margin":"50px 0px 0px 200px"}},[_c('div',[_c('h1',{staticClass:"my-3",staticStyle:{"color":"#310059"}},[_vm._v("Applications")]),_c('ApplicationTable',{attrs:{"reviewers":_vm.reviewer.reviewers,"applications":_vm.reviewer.applications,"loading":_vm.reviewer.loading}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }